import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";
import Map, { GeolocateControl, Marker } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import Menu from "../Components/Menu";
import { baseUrl } from "../Components/baseUrl";

const EditProfile = () => {
    const navigate = useNavigate();
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => {
        document.title = "ویزیت | ویرایش فروشگاه";
        token == null && navigate("/login", { replace: true });
    }, []);
    const { shopId } = useParams();

    const [allStates, setAllStates] = useState([]);
    useEffect(() => {
        let config = {
            url: `${baseUrl}/states`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setAllStates(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    const [allGuild, setAllGuild] = useState([]);
    useEffect(() => {
        let config = {
            url: `${baseUrl}/guilds`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setAllGuild(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    const [allCitys, setAllCitys] = useState([]);
    const getCitysHandler = (id) => {
        let config = {
            url: `${baseUrl}/sub-location?id=${id}`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setAllCitys(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const [allRegions, setAllRegions] = useState([]);
    const getRegionsHandler = (id) => {
        let config = {
            url: `${baseUrl}/sub-location?id=${id}`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res &&
                    res.data &&
                    res.data.data &&
                    setAllRegions(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const [allDestics, setAllDestics] = useState([]);
    const getDistrictHandler = (id) => {
        let config = {
            url: `${baseUrl}/sub-location?id=${id}`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res &&
                    res.data &&
                    res.data.data &&
                    setAllDestics(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const [storeName, setStoreName] = useState("");
    const [name, setName] = useState("");
    const [family, setFamily] = useState("");
    const [phone, setPhone] = useState("");
    const [mobile, setMobile] = useState("");
    const [avatar, setAvatar] = useState("");
    const [stateId, setStateId] = useState("");
    const [cityId, setCityId] = useState("");
    const [region, setRegion] = useState("");
    const [district, setDistrict] = useState("");
    const [address, setAddress] = useState("");
    const [guild, setGuild] = useState("");
    const [credit, setCredit] = useState("");
    const [loading, setLoading] = useState(false);
    const editShopHandler = (i) => {
        setLoading(true);
        let data = new FormData();
        data.append("store_name", storeName);
        data.append("name", name);
        data.append("family", family);
        phone && data.append("phone", phone);
        data.append("mobile", mobile);
        data.append("lat", selectedLocation.lat);
        data.append("lng", selectedLocation.lng);
        typeof avatar !== "string" && avatar && data.append("avatar", avatar);
        data.append("state_id", stateId);
        data.append("city_id", cityId);
        data.append("region_id", region);
        data.append("district_id", district);
        data.append("address", address);
        data.append("guild_id", guild);
        credit && data.append("user_credit", credit);
        data.append("customer_id", shopId);
        let config = {
            url: `${baseUrl}/profile`,
            method: "POST",
            data: data,
        };
        axios(config)
            .then((res) => {
                setLoading(false);
                toast.success(res.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                navigate("/panel/profile");
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    // Location
    const [selectedLocation, setSelectedLocation] = useState(null);

    const handleMapClick = (event) => {
        const { lngLat } = event;
        setSelectedLocation({
            lat: lngLat.lat,
            lng: lngLat.lng,
        });
    };
    // End Location
    console.log(selectedLocation);

    useEffect(() => {
        let config = {
            url: `${baseUrl}/profile`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                if (res.data && res.data.data) {
                    const shopData = res?.data?.data;
                    setStoreName(shopData?.store_name);
                    setName(shopData?.name);
                    setFamily(shopData?.family);
                    setPhone(shopData?.phone);
                    setMobile(shopData?.mobile);
                    shopData?.lat !== "null" &&
                        shopData?.lng !== "null" &&
                        setSelectedLocation({
                            lat: shopData?.lat,
                            lng: shopData?.lng,
                        });
                    setAvatar(shopData?.avatar);
                    setStateId(shopData?.location?.state?.id);
                    shopData?.location?.state?.id &&
                        getCitysHandler(shopData?.location?.state?.id);
                    setCityId(shopData?.location?.city?.id);
                    shopData?.location?.city?.id &&
                        getRegionsHandler(shopData?.location?.city?.id);
                    setRegion(shopData?.location?.region?.id);
                    shopData?.location?.region?.id &&
                        getDistrictHandler(shopData?.location?.region?.id);
                    setDistrict(shopData?.location?.district?.id);
                    setAddress(shopData?.address);
                    setGuild(shopData?.guild?.id);
                    setCredit(shopData?.user_credit);
                }
            })
            .catch((err) => {
                err?.response?.data?.message &&
                    toast.error(err.response.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
            });
    }, []);
    return (
        <div>
            <div className="container">
                <div className="add-cus-main">
                    <h1>
                        ویرایش فروشگاه
                        <svg
                            width="81"
                            height="115"
                            viewBox="0 0 81 115"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M31.3582 25.4804L37.4298 17.3203L49.2126 1.48444C49.3276 1.32993 49.5731 1.41125 49.5731 1.60383V48.2778C49.5731 48.3883 49.6626 48.4778 49.7731 48.4778H78.9361C79.3472 48.4778 79.5826 48.9465 79.3372 49.2763L31.7187 113.275C31.6037 113.429 31.3583 113.348 31.3583 113.155V66.4812C31.3583 66.3707 31.2687 66.2812 31.1583 66.2812H1.99525C1.58411 66.2812 1.34868 65.8126 1.59411 65.4827L13.1433 49.9609L19.2149 41.8007"
                                stroke="#2F80ED"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                            />
                        </svg>
                    </h1>
                    {avatar && avatar !== null ? (
                        <div className="img-box mt-4px">
                            {typeof avatar !== "string" ? (
                                <img
                                    src={
                                        avatar !== undefined &&
                                        window.URL.createObjectURL(avatar)
                                    }
                                    alt=""
                                />
                            ) : (
                                <img src={avatar && avatar} alt="" />
                            )}
                            {avatar !== undefined && (
                                <button
                                    onClick={() => setAvatar()}
                                    className="btn btn-danger remove-image"
                                >
                                    حذف
                                </button>
                            )}
                        </div>
                    ) : (
                        <label>
                            <input
                                type="file"
                                id="selectedFile"
                                className="d-none"
                                onChange={(e) => setAvatar(e.target.files[0])}
                            />
                            <input
                                className="inp-file"
                                type="button"
                                value="تصویر"
                                onClick={() =>
                                    document
                                        .getElementById("selectedFile")
                                        .click()
                                }
                            />
                            <svg
                                className="pic-svg"
                                width="26"
                                height="26"
                                viewBox="0 0 26 26"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="13" cy="13" r="13" fill="#D9D9D9" />
                                <path
                                    d="M14.225 7H14.2712C15.1761 7 15.9714 7.59989 16.22 8.47L16.2771 8.66996C16.4091 9.13168 16.8311 9.45 17.3113 9.45V9.45C18.7962 9.45 20 10.6538 20 12.1387V14.35C20 17.0562 17.8062 19.25 15.1 19.25H10.9C8.1938 19.25 6 17.0562 6 14.35V12.1388C6 10.6538 7.20379 9.45 8.68875 9.45V9.45C9.16894 9.45 9.59095 9.13168 9.72287 8.66996L9.78 8.47C10.0286 7.59989 10.8239 7 11.7288 7H11.775"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M10.9 13.65C10.9 12.4902 11.8402 11.55 13 11.55C14.1598 11.55 15.1 12.4902 15.1 13.65C15.1 14.8098 14.1598 15.75 13 15.75C12.71 15.75 12.4337 15.6912 12.1824 15.5849"
                                    stroke="#333333"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </label>
                    )}
                    <input
                        onChange={(e) => setName(e.target.value)}
                        value={name}
                        type="text"
                        name="name"
                        placeholder="نام"
                    />
                    <input
                        onChange={(e) => setFamily(e.target.value)}
                        value={family}
                        type="text"
                        name="family"
                        placeholder="نام خانوادگی"
                    />
                    <input
                        onChange={(e) => setStoreName(e.target.value)}
                        value={storeName}
                        type="text"
                        name="shop"
                        placeholder="نام فروشگاه"
                    />
                    {/* <select className="select-loc" name="country">
                        <option value="">کشور</option>
                        <option value="ایران">ایران</option>
                        <option value="افغانستان">افغانستان</option>
                    </select> */}
                    <select
                        onChange={(e) => {
                            setStateId(e.target.value);
                            getCitysHandler(e.target.value);
                        }}
                        className="select-loc"
                        name="state"
                    >
                        <option value="" selected disabled>
                            استان
                        </option>
                        {allStates &&
                            allStates.length !== 0 &&
                            allStates.map((item) => {
                                return (
                                    <option
                                        selected={item.id == stateId}
                                        value={item.id}
                                    >
                                        {item.name}
                                    </option>
                                );
                            })}
                    </select>
                    <select
                        onChange={(e) => {
                            setCityId(e.target.value);
                            getRegionsHandler(e.target.value);
                        }}
                        className="select-loc"
                        name="city"
                    >
                        <option value="" selected disabled>
                            شهر
                        </option>
                        {allCitys &&
                            allCitys.length !== 0 &&
                            allCitys.map((item) => {
                                return (
                                    <option
                                        selected={item.id == cityId}
                                        value={item.id}
                                    >
                                        {item.name}
                                    </option>
                                );
                            })}
                    </select>
                    <select
                        onChange={(e) => {
                            setRegion(e.target.value);
                            getDistrictHandler(e.target.value);
                        }}
                        className="select-loc"
                    >
                        <option value="" selected disabled>
                            منطقه شهرداری
                        </option>
                        {allRegions &&
                            allRegions.length !== 0 &&
                            allRegions.map((item) => {
                                return (
                                    <option
                                        selected={item.id == region}
                                        value={item.id}
                                    >
                                        {item.name}
                                    </option>
                                );
                            })}
                    </select>
                    <select
                        onChange={(e) => {
                            setDistrict(e.target.value);
                        }}
                        className="select-loc"
                    >
                        <option value="" selected disabled>
                            مسیر
                        </option>
                        {allDestics &&
                            allDestics.length !== 0 &&
                            allDestics.map((item) => {
                                return (
                                    <option
                                        selected={
                                            district !== undefined &&
                                            district !== null &&
                                            item.id == district
                                        }
                                        value={item.id}
                                    >
                                        {item.name}
                                    </option>
                                );
                            })}
                    </select>
                    <select
                        onChange={(e) => {
                            setGuild(e.target.value);
                        }}
                        className="select-loc"
                    >
                        <option value="" selected disabled>
                            صنف
                        </option>
                        {allGuild &&
                            allGuild.length !== 0 &&
                            allGuild.map((item) => {
                                return (
                                    <option
                                        selected={item.id == guild}
                                        value={item.id}
                                    >
                                        {item.name}
                                    </option>
                                );
                            })}
                    </select>
                    <input
                        onChange={(e) => setPhone(e.target.value)}
                        value={phone}
                        type="number"
                        name="shop"
                        placeholder="تلفن ثابت با کد شهر"
                    />
                    <input
                        onChange={(e) => setMobile(e.target.value)}
                        value={mobile}
                        type="number"
                        name="shop"
                        placeholder="شماره موبایل"
                    />
                    <input
                        onChange={(e) => setCredit(e.target.value)}
                        value={credit}
                        type="text"
                        name="shop"
                        placeholder="اعتبار مورد نیاز"
                    />
                    <textarea
                        onChange={(e) => setAddress(e.target.value)}
                        value={address}
                        name="description"
                        placeholder="آدرس پستی"
                    ></textarea>
                    <Map
                        style={{ height: "calc(100vh - 260px)" }}
                        initialViewState={{
                            longitude: selectedLocation
                                ? selectedLocation.lng
                                : 51.375433528216654,
                            latitude: selectedLocation
                                ? selectedLocation.lat
                                : 35.73356434056531,
                            zoom: 11,
                        }}
                        mapboxAccessToken="pk.eyJ1IjoiYWxkZjkyIiwiYSI6ImNscHh5ZG56dTByMXAycnJ2cDNmdDQ5M3YifQ.a_sUt1rLFMfA0jHrETcM7A"
                        mapStyle="mapbox://styles/mapbox/streets-v11"
                        transformRequest={(url) => {
                            return {
                                url,
                            };
                        }}
                        onClick={handleMapClick}
                    >
                        <GeolocateControl />
                        {selectedLocation && (
                            <Marker
                                latitude={selectedLocation.lat}
                                longitude={selectedLocation.lng}
                                offsetLeft={-20}
                                offsetTop={-10}
                            >
                                <svg
                                    width="24"
                                    height="27"
                                    viewBox="0 0 57 65"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M55.4409 21.4062C52.1597 6.96875 39.5659 0.46875 28.5034 0.46875C28.5034 0.46875 28.5034 0.46875 28.4722 0.46875C17.4409 0.46875 4.81585 6.9375 1.5346 21.375C-2.12165 37.5 7.75335 51.1562 16.6909 59.75C20.0034 62.9375 24.2534 64.5312 28.5034 64.5312C32.7534 64.5312 37.0034 62.9375 40.2847 59.75C49.2222 51.1562 59.0972 37.5312 55.4409 21.4062ZM28.5034 37.0625C23.0659 37.0625 18.6596 32.6562 18.6596 27.2188C18.6596 21.7813 23.0659 17.375 28.5034 17.375C33.9409 17.375 38.3472 21.7813 38.3472 27.2188C38.3472 32.6562 33.9409 37.0625 28.5034 37.0625Z"
                                        fill="#1AA3B9"
                                    />
                                </svg>
                            </Marker>
                        )}
                    </Map>
                    {!loading ? (
                        <button
                            className="add-cus-btn"
                            onClick={editShopHandler}
                        >
                            ثبت تغییرات
                        </button>
                    ) : (
                        <button className="add-cus-btn">
                            <img src="/assets/images/loading.gif" width={20} />
                        </button>
                    )}
                </div>
            </div>
            <Menu active="shop" />
        </div>
    );
};

export default EditProfile;
